// import React, { useEffect, useState } from 'react';
// import '../PermissionList/permissionList.css'
// import check from '../../assets/images/Permissions_Page_Chack_Box_On.png'
// import editIcon from '../../assets/images/Permissions_Page_Edit_Button.png'
// import AddPermission, { User } from '../AddPermission/AddPermission';
// import UserService from '../../Services/UserService';

// interface PermissionsListProps {
//   editingIndex: number | null;
//   setEditingIndex: (index: number | null) => void;
//   onSaveUser: (user: User, index?: number) => void;
// }

// const PermissionsList: React.FC<PermissionsListProps> = ({ editingIndex, setEditingIndex, onSaveUser }) => {
//   const [users, setUsers] = useState<User[]>([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     UserService.getUsers()
//       .then((data) => {
//         setUsers(data);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Error fetching users", err);
//         setLoading(false);
//       });
//   }, []);

//   if (loading) return <div>טוען משתמשים...</div>;

//   return (
//     <div className="permissions-wrapper">
//       <table className="permissions-table">
//         <tbody>
//           {users.map((user, index) => (
//             <React.Fragment key={index}>
//               {editingIndex === index ? (
//                 <tr className="lineOfPermission">
//                   <td colSpan={5}>
//                     <AddPermission
//                       setShowUserForm={() => setEditingIndex(null)}
//                       onSave={(updatedUser) => onSaveUser(updatedUser, index)}
//                       user={user}
//                     />
//                   </td>
//                 </tr>
//               ) : (
//                 <tr className="lineOfPermission">
//                   <td><strong>שם מלא - </strong>{user.fullName}</td>
//                   <td><strong>טלפון - </strong>{user.phone}</td>
//                   <td><strong>אימייל - </strong>{user.email}</td>
//                   <td className="permissions-column">
//                     <strong>בחר הרשאות :</strong>
//                     {user.permissions.map((permission, idx) => (
//                       <div key={idx} className="permission-item">
//                         <span>{permission}</span>
//                         <img src={check} alt="✔"/>
//                       </div>
//                     ))}
//                   </td>
//                   <td className="edit-column">
//                     <img
//                       src={editIcon}
//                       alt="ערוך"
//                       className="edit-icon"
//                       onClick={() => setEditingIndex(index)}
//                     />
//                   </td>
//                 </tr>
//               )}
//             </React.Fragment>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default PermissionsList;

import React, { useEffect, useState } from 'react';
import '../PermissionList/permissionList.css'
import check from '../../assets/images/Permissions_Page_Chack_Box_On.png'
import editIcon from '../../assets/images/Permissions_Page_Edit_Button.png'
import AddPermission from '../AddPermission/AddPermission';
import  { getUsers, updateUser } from '../../Services/UserService';
import { useSelector } from 'react-redux';
import { User, UserPostModel } from '../../Items/User';

interface PermissionsListProps {
  editingIndex: number | null;
  setEditingIndex: (index: number | null) => void;
  searchTerm: string; 
}

const PermissionsList: React.FC<PermissionsListProps> = ({ editingIndex, setEditingIndex ,searchTerm}) => {
  const allUsers = useSelector((state:any) => state.User.users); 
  const [users, setUsers] = useState<User[]>([]);
 

  useEffect(() => {
    getUsers()
      .then((data) => {
        setUsers(data);
  
      })
      .catch((err) => {
        console.error("Error fetching users", err);

      });
  }, []);

    // סינון משתמשים לפי החיפוש
    const filteredUsers = allUsers.filter((user:any) =>
      Object.values(user).some(val =>
        val && val.toString().toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  

  const handleSaveUser = async (updatedUser: UserPostModel, index: number) => {
    try {
      const userId = users[index].id;
      if (!userId) throw new Error("User ID is missing");
  
      // שולח ל-backend את ה-UserPostModel
      const savedUser: User = await updateUser(userId, updatedUser); // מחזיר User
  
      const newUsers = [...users];
      newUsers[index] = savedUser;
      setUsers(newUsers);
      setEditingIndex(null);
    } catch (err) {
      console.error("Error updating user", err);
    }
  };



  return (
    <div className="permissions-wrapper">
      <table className="permissions-table">
        <tbody>
          {filteredUsers.map((user:any, index:any) => (
            <React.Fragment key={index}>
              {editingIndex === index ? (
                <tr className="lineOfPermission">
                  <td colSpan={5}>
                  <AddPermission
                setShowUserForm={() => setEditingIndex(null)}
                onSave={(updatedUser: UserPostModel) => handleSaveUser(updatedUser, index)}
                user={user} 
                    />
                  </td>
                </tr>
              ) : (
                <tr className="lineOfPermission">
                  <td><strong>שם מלא - </strong>{user.fullName}</td>
                  <td><strong>טלפון - </strong>{user.phone}</td>
                  <td><strong>אימייל - </strong>{user.email}</td>
                  {/* <td><strong>סיסמה - </strong>{user.passwordHash}</td> */}

                  <td className="permissions-column">
                    <strong>בחר הרשאות :</strong>
                    {user.permissions.map((permission:any, idx:any) => (
                      <div key={idx} className="permission-item">
                         <img src={check} alt="✔"/>
                        <span>{permission.name ?? permission}</span>
                      </div>
                    ))}
                  </td>
                  <td className="edit-column">
                    <img
                      src={editIcon}
                      alt="ערוך"
                      className="edit-icon"
                      onClick={() => setEditingIndex(index)}
                    />
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PermissionsList;